import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { setLoading } from 'redux/slices/uiSlice';
import { errorAlert } from 'helpers/alerts';
import { hasSameValues } from 'helpers/util';
import CredProductForm from 'components/admin/CredProductForm';
import { updateCredPINProductService } from 'services/admin/providerService';
import { setPINProducts } from 'redux/slices/admin/providerSlice';

const EditCredPINProductScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    providerCredSelected: cred,
    currentPINProduct: product,
  } = useSelector((store) => store.providers);
  let values = {};
  if (product.fixedAmount)
    values.amounts = product.amounts.map(item => {
      const current = product.service?.amounts?.find(s => s.amount === item.amount);
      return { ...item, hebe_sku: item.sku, sku: current?.sku }
    });
  else
    values.sku = product.service?.sku;

  const handlerSubmit = async (data) => {
    dispatch(setLoading(true))
    if (data.amounts)
      data.amounts = data.amounts.filter(item => item.sku && item.sku !== '');
    updateCredPINProductService(cred.id, product.idSegment.id, product.id, data)
      .then(response => {
        dispatch(setPINProducts(response));
        navigate(-1);
      }).catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)))
  }

  const validate = (data) => !hasSameValues(values, data)

  return (
    <CredProductForm
      title="Editar PIN"
      subtitle={product?.name}
      fixedAmount={product?.fixedAmount}
      type={"pin"}
      goBack={() => navigate(-1)}
      defaultValues={values}
      submit={handlerSubmit}
      validate={validate}
    />
  );
}

export default EditCredPINProductScreen